import React, { useState, useEffect } from 'react';
import './App.css';

// Navigation Component
const Navigation = () => {
  return (
    <nav className="navbar">
      <div className="container">
        <div className="nav-brand">
          <img src="/baba_logo1.webp" alt="Chaityabhoomi Logo" />
        </div>
        <ul className="nav-menu">
          <li className="nav-item">
            <a href="#home" className="nav-link">Home</a>
          </li>
          <li className="nav-item">
            <a href="#about" className="nav-link">About Chaityabhoomi</a>
          </li>
          <li className="nav-item">
            <a href="#architecture" className="nav-link">Architecture & Features</a>
          </li>
          <li className="nav-item">
            <a href="#mahaparinirvan" className="nav-link">Mahaparinirvan Diwas</a>
          </li>
          <li className="nav-item">
            <a href="#visitor-info" className="nav-link">Visitor Information</a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

// Image Slider Component
const ImageSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      id: 1,
      // title: "Chaityabhoomi Memorial",
      // description: "The sacred cremation site of Dr. B.R. Ambedkar",
      // for best quality photo dimension should be 1920x1080 pixels.
      image: "/images/baba_photo2.avif"
    },
    {
      id: 2,
      // title: "Chaityabhoomi Memorial",
      // description: "The sacred cremation site of Dr. B.R. Ambedkar",
      // for best quality photo dimension should be 1920x1080 pixels.
      image: "/images/baba_photo3.webp"
    },
    /*{
      id: 3,
      // title: "Chaityabhoomi Memorial",
      // description: "The sacred cremation site of Dr. B.R. Ambedkar",
      // for best quality photo dimension should be 1920x1080 pixels.
      image: "/images/baba_photo1.webp"
    },*/
    {
      id: 3,
      // title: "Annual Gathering",
      // description: "Millions pay tribute every December 6th",
      image: "/images/cb_photo3.jpg"
    },
    {
      id: 4,
      // title: "Symbol of Equality",
      // description: "A monument to social justice and human rights",
      image: "/images/cb_photo2.jpg"
    },
    {
      id: 5,
      // title: "Symbol of Equality",
      // description: "A monument to social justice and human rights",
      image: "/images/cb_photo1.avif"
    }
  ];

  useEffect(() => {
    document.title = 'ChaityaBhoomi';
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 10000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className="slider">
      <div className="slider-wrapper">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`slide ${index === currentSlide ? 'active' : ''}`}
            style={{
              backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${slide.image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          >
            <div className="slide-content">
              <h2 className="slide-title">{slide.title}</h2>
              <p className="slide-description">{slide.description}</p>
            </div>
          </div>
        ))}
      </div>
      
      <button className="slider-btn prev" onClick={prevSlide}>
        &#10094;
      </button>
      <button className="slider-btn next" onClick={nextSlide}>
        &#10095;
      </button>
      
      <div className="slider-dots">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

// Header Component
const Header = () => {
  return (
    <header className="header">
      <div className="container">
        <h1 className="site-title">Chaityabhoomi</h1>
        <p className="subtitle">A Memorial That Continues to Awaken Consciences</p>
      </div>
    </header>
  );
};

// Hero Section Component
const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="hero-overlay">
        <div className="container">
          <h2 className="hero-title">Honoring Dr. B.R. Ambedkar</h2>
          <p className="hero-text">
            A Sacred Memorial to the Architect of India’s Constitution
          </p>
        </div>
      </div>
    </section>
  );
};

// About Section Component
const About = () => {
  return (
    <section className="about" id="about">
      <div className="container">
        <h2 className="section-title">About Chaityabhoomi</h2>
        <div className="about-content">
          <p>
            Chaityabhoomi, located at Shivaji Park in Dadar, Mumbai, stands as a powerful symbol of social justice, equality, and democratic values. It is the sacred cremation site of Dr. B. R. Ambedkar, the chief architect of the Indian Constitution and a tireless champion of the rights of the marginalized. More than just a memorial, Chaityabhoomi represents Dr. Ambedkar’s lifelong struggle against social discrimination and his vision of an inclusive and progressive India.
          </p>
          <p>
            Every year, millions of followers, scholars, and admirers from across the country gather here to pay homage, reflect on his teachings, and draw inspiration from his enduring legacy. The serene atmosphere, set against the backdrop of the sea, makes Chaityabhoomi a place of remembrance, reflection, and a renewed commitment to the ideals of liberty, equality, and fraternity that Dr. Ambedkar dedicated his life to upholding.
          </p>
          <p>
            Dr. Ambedkar passed away on December 6, 1956, and was cremated at this very site the following day. Since then, Chaityabhoomi has been transformed into a beautifully maintained memorial that continues to attract visitors from across India and around the world, serving as a timeless reminder of his monumental contributions to the nation and humanity.
          </p>
        </div>
      </div>
    </section>
  );
};

// Architecture & Features Section Component
const Architecture = () => {
  return (
    <section className="significance" id="architecture">
      <div className="container">
        <h2 className="section-title">Architecture & Features</h2>
        <div className="cards-grid">
          <div className="card">
            <h3>Memorial Stupa</h3>
            <p>
              The centerpiece is a magnificent Buddhist stupa that reflects Dr. Ambedkar's 
              conversion to Buddhism. The stupa's design symbolizes peace and enlightenment, 
              creating a serene atmosphere for visitors.
            </p>
          </div>
          <div className="card">
            <h3>Portrait & Statue</h3>
            <p>
              A large portrait of Dr. Ambedkar adorns the memorial, along with his statue 
              in a dignified pose. These serve as focal points for paying respects and 
              meditation.
            </p>
          </div>
          <div className="card">
            <h3>Garden & Pathways</h3>
            <p>
              Well-maintained gardens surround the memorial with walking pathways, providing 
              a peaceful environment for reflection. The landscaping includes native plants 
              and shaded areas for visitors.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

// Mahaparinirvan Diwas Section Component
const MahaparinirvhanDiwas = () => {
  return (
    <section className="mahaparinirvan" id="mahaparinirvan">
      <div className="container">
        <h2 className="section-title">Mahaparinirvan Diwas</h2>
        <div className="mahaparinirvan-content">
          <div className="mahaparinirvan-text">
            <h3>December 6th - A Day of Remembrance</h3>
            <p>
              Mahaparinirvan Diwas marks the death anniversary of Dr. B. R. Ambedkar, who passed away on December 6, 1956. The term “Mahaparinirvan” originates from Buddhist tradition and signifies the attainment of final nirvana after death, symbolizing liberation and eternal peace.
            </p>
            <p>
              On this solemn day, millions of followers, admirers, and scholars from across India and around the world gather at Chaityabhoomi to pay their heartfelt respects. The memorial becomes a vast sea of people, united in reverence for Babasaheb’s life, struggles, and teachings. Mahaparinirvan Diwas stands not only as a moment of remembrance, but also as a powerful reaffirmation of the values of equality, justice, and human dignity that Dr. Ambedkar devoted his life to championing.
            </p>
          </div>
          <div className="mahaparinirvan-features">
            <div className="feature-box">
              <h4>🕯️ Prayer Ceremonies</h4>
              <p>Buddhist prayers and chanting throughout the day</p>
            </div>
            <div className="feature-box">
              <h4>📚 Cultural Programs</h4>
              <p>Speeches, discussions on Dr. Ambedkar's philosophy</p>
            </div>
            <div className="feature-box">
              <h4>👥 Mass Gathering</h4>
              <p>Millions of devotees from all over the world</p>
            </div>
            <div className="feature-box">
              <h4>🌸 Floral Tributes</h4>
              <p>Visitors offer flowers and pay homage</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Visiting Info Component
const VisitingInfo = () => {
  return (
    <section className="visiting-info" id="visitor-info">
      <div className="container">
        <h2 className="section-title">Visitor Information</h2>
        <div className="info-grid">
          <div className="info-box">
            <h3>📍 Location</h3>
            <p>Shivaji Park, Dadar, Mumbai, Maharashtra 400028</p>
          </div>
          <div className="info-box">
            <h3>🕐 Timings</h3>
            <p>Open daily from 6:00 AM to 9:00 PM</p>
          </div>
          <div className="info-box">
            <h3>🎫 Entry</h3>
            <p>Free entry for all visitors</p>
          </div>
          <div className="info-box">
            <h3>⏰ Best Time to Visit</h3>
            <p>Early morning or evening for peaceful atmosphere</p>
          </div>
        </div>
        <div className="visitor-tips">
          <h3>Tips for Visitors</h3>
          <ul>
            <li>Dress modestly and respectfully</li>
            <li>Photography is allowed but be respectful</li>
            <li>Nearest railway station: Dadar (Central & Western lines)</li>
            <li>Avoid visiting on December 6th unless you want to experience the massive gathering</li>
            <li>Maintain silence and decorum within the memorial premises</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

// Footer Component
const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>&copy; 2026 Chaityabhoomi Memorial. A tribute to Dr. B.R. Ambedkar.</p>
        <p className="footer-quote">
          "I measure the progress of a community by the degree of progress which women have achieved."
          <br />
          <span>- Dr. B.R. Ambedkar</span>
        </p>
      </div>
    </footer>
  );
};

// Main App Component
function App() {
  return (
    <div className="App">
      <Navigation />
      <ImageSlider />
      <Header />
      <Hero />
      <About />
      <Architecture />
      <MahaparinirvhanDiwas />
      <VisitingInfo />
      <Footer />
    </div>
  );
}

export default App;
